export enum DisplayStyles {
  none = 'none',
  flex = 'flex',
}
